module.exports = __webpack_public_path__ + "static/media/1009801.258e3f21.jpg";